import { render, staticRenderFns } from "./goodslist.vue?vue&type=template&id=f872d3ee&scoped=true&"
import script from "./goodslist.vue?vue&type=script&lang=js&"
export * from "./goodslist.vue?vue&type=script&lang=js&"
import style0 from "./goodslist.vue?vue&type=style&index=0&id=f872d3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872d3ee",
  null
  
)

export default component.exports